import { ACTIONS } from "../constants"


const initialState = { 
  partnerTypes: [], 
  partnerType: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: false,
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_PARTNER_TYPE : {
      return { ...state, success: false, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_PARTNER_TYPES_INIT : {
      return { ...state, isFetching: true, success: false, error: null }
    }
    case ACTIONS.FETCH_PARTNER_TYPES_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, partnerTypes: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_PARTNER_TYPES_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_PARTNER_TYPE_INIT : {
      return { ...state, isLoading: true, error: null, success: false }
    }
    case ACTIONS.CREATE_PARTNER_TYPE_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_PARTNER_TYPE_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_PARTNER_TYPE_INIT : {      
      return { ...state, isLoading: true, error: null, success:false }
    }
    case ACTIONS.EDIT_PARTNER_TYPE_SUCCEDED : {
      return { ...state, partnerType: payload, success: true, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_PARTNER_TYPE_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_PARTNER_TYPE_INIT : {
      return { ...state, isLoading: true, partnerType: null, error: null }
    }
    case ACTIONS.FETCH_PARTNER_TYPE_SUCCEDED : {
      return { ...state, partnerType: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_PARTNER_TYPE_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_PARTNER_TYPE_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_PARTNER_TYPE_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_PARTNER_TYPE_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_PARTNER_TYPES_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_PARTNER_TYPES_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_PARTNER_TYPES_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_PARTNER_TYPE_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_PARTNER_TYPE_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_PARTNER_TYPE_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_PARTNER_TYPES_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_PARTNER_TYPES_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_PARTNER_TYPES_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
